import { Partner } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { createAppAsyncThunk } from 'src/state/thunk-api';

export const fetchPartnersActionCreator = createAppAsyncThunk<Partner[]>('request/fetchPartners', async () =>
  api.partnerController.getPartners(),
);
